export default {
  UPDATE_SELECTED_ADDRESS: '@ADDRESS/UPDATE_SELECTED_ADDRESS',
} as const
